import { render, staticRenderFns } from "./ListPagination.vue?vue&type=template&id=99bb4ec2&scoped=true&"
import script from "./ListPagination.vue?vue&type=script&lang=js&"
export * from "./ListPagination.vue?vue&type=script&lang=js&"
import style0 from "./ListPagination.vue?vue&type=style&index=0&id=99bb4ec2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bb4ec2",
  null
  
)

export default component.exports